import "./App.css";
import Header from "./components/Header";
import Chat from "./components/chat/Chat";
import styled from "styled-components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { useState } from "react";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 0,
      },
    },
  });

  const [profileModal, setProfileModal] = useState(false);
  const onClickProfileModal = () => {
    setProfileModal(!profileModal);
  };

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route
              path="/"
              element={
                <MainWrapper>
                  <Header onClickProfileModal={onClickProfileModal} />
                  <Chat
                    profileModal={profileModal}
                    onClickProfileModal={onClickProfileModal}
                  />
                </MainWrapper>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </>
  );
}

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
`;

export default App;
